import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import styles from '../../CommunityPage.module.scss';
import ListItem from './ListItem';

const ListMode = ({ users, onScroll, loading }) => (
  <Box className={styles.expertsList} onScroll={onScroll}>
    {users && users.map((user) => <ListItem user={user} />)}
  </Box>
);

export default ListMode;
